
import { Graph } from '../pathfinding/Graph';

export class CollisionGraph {
    constructor(tilemap) {

        this.collisions = new Graph(tilemap.map.movementData.mask, tilemap.map.width, tilemap.map.height, { diagonal: true });
        this.collectibles = new Graph(tilemap.map.collectionData.mask, tilemap.map.width, tilemap.map.height, { diagonal: true });
        this.obstacles = [];
        this.entities = [];
        this.teleports = tilemap.map.teleportData.teleports;

        this.tilemap = tilemap;
        this.map = this.tilemap.map;
        this.movementData = this.map.movementData;
    }

    addStaticEntity(entity) {
        this.entities.push(entity);
        //this.addBlock(entity.tilePos);
    }

    removeStaticEntity(entity) {
        //this.removeBlock(entity.tilePos);
        this.entities = this.entities.filter((arrEntity) => entity.id !== arrEntity.id);
    }

    addObstacles(obstacle) {
        this.obstacles.push(obstacle);
    }

    removeObstacles(obstacle) {
        this.obstacles = this.obstacles.filter((arrObstacles) => obstacle.id !== arrObstacles.id);
    }

    checkForEntity(tilePos) {
        let entity = this.entities.find((entity) => {
            return entity.tilePos.x === tilePos.x && entity.tilePos.y === tilePos.y;
        });

        return entity ? true : false;
    }

    checkForObstacle(player, tilePos) {
        let obstacle = this.obstacles.find((obstacle) => {
            return obstacle.tilePos.x === tilePos.x && obstacle.tilePos.y === tilePos.y;
        });

        if (obstacle) {
            player.applyEffect(obstacle.effect);
            obstacle.destroy();
        }

        return obstacle ? true : false;
    }

    /*
    check(tilePos) {
        return this.getNodeFromXY(tilePos)?.weight > 0;
    }

    addBlock(tilePos) {
        this.setNode(tilePos, true);
    }

    removeBlock(tilePos) {
        this.setNode(tilePos, false);
    }
    */

    checkForCollectible(tilePos) {
        let node = this.collectibles.getNodeFromXY(tilePos);
        if (node.weight !== 0) {
            this.unlockCollectible(this.tilemap.collectibles.get(node.index));
            let neighbours = this.collectibles.getNeighbours(node);
            for (var i = 0; i < neighbours.length; i++) {
                this.unlockCollectible(this.tilemap.collectibles.get(neighbours[i].index));
            }
        }
    }

    checkForTeleporter(player, tilePos) {
        let worldPos = this.tilemap.localToWorldXY(tilePos.x, tilePos.y);
        for (let i = 0; i < this.teleports; i++){
            // console.log("Checking for teleports...");
            // this.teleports.Contains(worldPos);
            if (this.teleports.Contains(worldPos.x, worldPos.y)){
                console.log("------------------TELEPORTER--------------------");
            }
        }
        
    }

    unlockCollectible(col){
        if (col !== undefined){
            col.onCollected();
        }
    }
}
